import { RiLoader5Fill } from 'react-icons/ri'
import cx from 'classnames'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import './react-tab.css'
import CsvLink from './CsvLink'

export default function ChartWrapper(props) {
  const {
    title,
    loading,
    csvFields,
    data,
    controls,
    viewState = {},
    togglePercentView,
    csvStartTimestampField = undefined,
    csvEndTimestampField = undefined,
    onChangeTabs = undefined,
    currentTabIndex = 0,
    tabHeaderValues = [],
  } = props

  const csvData = data || null

  return (
    <>
      <div className="chart-header">
        <h3>
          {title}
          <CsvLink
            fields={csvFields}
            name={title}
            data={csvData}
            startTimestampField={csvStartTimestampField}
            endTimestampField={csvEndTimestampField}
          />
        </h3>
        {controls && (
          <div className="chart-controls">
            {controls.convertToPercents && (
              <div
                className={cx({
                  'chart-control-checkbox': true,
                  active: viewState.isPercentsView,
                })}
                onClick={togglePercentView}
              >
                %
              </div>
            )}
          </div>
        )}

        {onChangeTabs && tabHeaderValues.length > 0 && (
          <Tabs onSelect={onChangeTabs} selectedIndex={currentTabIndex}>
            <TabList>
              {tabHeaderValues.map((_val, _index) => (
                <Tab key={_val}>{_val}</Tab>
              ))}
            </TabList>
            {tabHeaderValues.map((_val) => (
              <TabPanel key={_val}></TabPanel>
            ))}
          </Tabs>
        )}
      </div>
      {loading && !data && <RiLoader5Fill size="3em" className="loader" />}
      {props.children}
    </>
  )
}
